import { useCallback, useEffect, useMemo } from "react";
import { Breadcrumb, Button, Rate, Tooltip, Typography,Card, Row, Col  } from "antd";
import {useHistory, useParams} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import TripsTable from "./tripTable";
import { UserTile } from "components";
import { Table, Tag } from "components/base";
import { riderTrips } from "store/actions";
import {
  getDownloadedBytes,
  getRiderStats, getUpdatedUser,
  setModalName,
  setSelectedUser,
} from "store/actions";
import {
  backIcon,
  phoneIcon,
  mailIcon,
  cameraIcon,
  halmetIcon,
  distanceIcon,
  ratingIcon,
  bikeIcon,
  userDetailClockIcon,
  checkIcon,
  clipboardIcon,
  editIcon,
  holdIcon,
  efficiencyIcon,
  uploadedFileIcon,
  downloadFileIcon,
} from "svgs";
import { AppState } from "store";
import { UsersState } from "types";
import { USER_TYPE } from "utils/mapped-data";
import { getMockLocation } from "components/tab-content/users-content/__mock__";
import { getHref } from "utils/helpers";
import { DEFAULT_AVATER } from "utils/constants";
import { parseStats } from "utils/parsers/users-parsers";



const { Title } = Typography;

const columns = [
  {
    title: "title",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "Value",
    dataIndex: "value",
    key: "value",
  },
];

const getData = (user?: UsersState["selectedUser"]) => {
  const href = getHref(user?.document, user?.documentType);
  const allUserData = [
    {
      key: "1",
      title: "CNIC",
      value: user?.nationalId
      ,
    },
    {
      key: "2",
      title: "Role",
      value: user?.type ? USER_TYPE[user?.type] : "",
    },
  
    {
      key: "4",
      title: "Organization Name",
      value: user?.organization_name,
    },
    // {
    //   key: "5",
    //   title: "Rider's Pickup Location",
    //   value: getMockLocation(user?.vehicle?.[0]?.vehicleId?.toString() || ""),
    // },
    // {
    //   key: "6",
    //   title: "License Number",
    //   value: user?.lincenceNo,
    // },
    {
      key: "3",
      title: "Assigned Vehicles",
      value: user?.vehicle ? (
        user.vehicle?.map((v) => (
          <Tag customClasses="user-tag vehicle-id-tag">
            {v.vehicleLicensePlate}
          </Tag>
        ))
      ) : (
        <span />
      ),
    },
    // {
    //   key: "7",
    //   title: "Document Upload",
    //   value: user?.documentName ? (
    //     <Tooltip title={user?.documentName} className="uploadded-file">
    //       <span className="file-icon">{uploadedFileIcon}</span>
    //       <section className="file-info">
    //         <span className="--name">{user?.documentName}</span>
    //         <span className="--size"></span>
    //       </section>
    //       <a
    //         href={href}
    //         download={user?.documentName}
    //         className="download-file-icon"
    //       >
    //         {downloadFileIcon}
    //       </a>
    //     </Tooltip>
    //   ) : (
    //     ""
    //   ),
    // },
  ];

  return user?.type !== 3
    ? allUserData.filter((data) => data.key !== "3")
    : allUserData;
};

const tasks = [
  {
    icon: <span className="--sea-green">{checkIcon}</span>,
    value: <span className="value">300</span>,
    title: "Total Tasks",
    // link: (
    //   <a href="" className="link ">
    //     View
    //   </a>
    // ),
  },
  {
    icon: <span className="--purple">{clipboardIcon}</span>,
    value: <span className="value">03</span>,
    title: "Active Tasks",
    // link: (
    //   <a href="" className="link ">
    //     View
    //   </a>
    // ),
  },
  {
    icon: <span className="--yellow">{clipboardIcon}</span>,
    value: (
      <section>
        <span className="value">1,200 </span>
        <span className="till-date">- TILL DATE</span>
      </section>
    ),
    title: "Total Tasks Assigned",
  },
];

type UserDetailParams = {
  userId?: string; // optional because your param is optional
};

export default function UserDetail() {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    riderStats: { riderStats },
  } = useSelector<AppState, AppState>((state) => state);
  const { selectedUser
   } = useSelector<AppState, AppState["users"]>(
    (state) => state.users
  );
  const {
   riderTripsPage: { selectedPage , totalElements },
 } = useSelector<AppState, AppState["trips"]>((state) => state.trips);
  const { userId } = useParams<UserDetailParams>();
   const stats = useMemo(() => parseStats(riderStats), [riderStats]);


  const generalStats = useMemo(() => {
    return [
       {
        icon: <span className="--blue">{userDetailClockIcon}</span>,
        value: (
          <section>
            <span className="value">{stats?.totalDrivingTime || "0:00"}</span>
            <span className="unit"> </span>
          </section>
        ),
        title: "Total Driving Time",
      },
      {
        icon: <span className="--orange">{distanceIcon}</span>,
        value: (
          <section>
            <span className="value">{stats?.totalKilometer || 0}</span>
            <span className="unit"> kms.</span>
          </section>
        ),
        title: "Total Driving Distance",
      },
      {
        icon: <span>{efficiencyIcon}</span>,
        value: <span className="value">{stats?.rangeScore?.toFixed(2) || 0}</span>,
        title: "Range Score",
      },
      {
        icon: <span className="--yellow">{ratingIcon}</span>,
        value: <span className="value">{stats?.driverScore?.toFixed(2) || 0}</span>,
        title: "Efficient Driving Score",
      },
      
      {
        icon: <span className="--niagara">{bikeIcon}</span>,
        value: <span className="value">{stats?.consistencyScore?.toFixed(2) || 0}</span>,
        title: "Consistency Score",
      },
       {
        icon: <span className="--blue">{halmetIcon}</span>,
        value: <span className="value">{stats?.overallScore?.toFixed(2) || 0}</span>,
        title: "Overall Score", 
      },
    ];
  }, [stats]);

  const {
    common: { userType= 1 }
  } = useSelector<AppState, AppState>((state) => state);
  const onClickBack = useCallback(() => {
    history.goBack();
  }, [history]);

  // const onEditUser = useCallback(() => {
  //   dispatch(setModalName("edit_user"));
  // }, [dispatch]);

  const onUploadPic = useCallback(() => {
    dispatch(setModalName("upload_pic"));
  }, [dispatch]);

  const downloadFile = useCallback(() => {
    if (selectedUser?.documentLink) {
      dispatch(
        getDownloadedBytes(selectedUser.documentLink, (resp) => {
          dispatch(
            setSelectedUser({ ...selectedUser, document: resp.getFileData() })
          );
        })
      );
    }
  }, [dispatch, selectedUser]);


  useEffect(() => {
    if (!selectedUser) {
      dispatch(getUpdatedUser(userId || ""))
    }
    if (selectedUser) {
      dispatch(riderTrips({
        pageNo: selectedPage,
       user_id:selectedUser?.id || "",
      }));
      (Number(selectedUser?.type) === 3 || Number(selectedUser?.type) === 5 ) &&   dispatch(getRiderStats(selectedUser?.phone));
        downloadFile();
    }

  }, [dispatch, downloadFile, selectedUser?.documentLink, selectedUser,selectedPage]);

  // const onArchive = useCallback(() => {
  //   dispatch(setModalName("block_account"));
  // }, [dispatch]);

  console.log(selectedUser);
  return (
    <>
      <header className="user-detail-header">
        <section>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Button
                type="link"
                className="breadcrumb-active"
                onClick={onClickBack}
              >
                Users
              </Button>
            </Breadcrumb.Item>
            <Breadcrumb.Item>User Details</Breadcrumb.Item>
          </Breadcrumb>
        </section>
        {userType != 6 && <section className="header-actions">
          {/* <Button onClick={onEditUser}>{editIcon} Edit</Button>
          <Button type="primary" danger onClick={onArchive}>
            {holdIcon} Block Account
          </Button> */}
        </section> }
      </header>
      <main className="user-detail-content" >
        <Button type="link" onClick={onClickBack} className="--back-btn">
          {/* {backIcon} */}
        </Button>
        <div className="user-detail-row">
  {/* LEFT PROFILE CARD */}
  <Card
    className="modern-card profile-card"
    bordered={false}
    style={{
      flex: 1,
      marginRight: 16,
      boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
      minHeight: "180px",
    }}
  >
    <section className="profile">
      <figure className="--pic-container">
        <img src={selectedUser?.imgUrl || DEFAULT_AVATER} alt="user pic" />
      </figure>
      <article className="user">
        <Title className="--name">{selectedUser?.name}</Title>
        <span className="--contact-info">
          <span className="--icon">{phoneIcon}</span> {selectedUser?.phone}
        </span>
        <span
          className="--contact-info email-wrap"
          style={{
            display: "block",
            wordBreak: "break-all",
            whiteSpace: "normal",
            overflowWrap: "anywhere",
          }}
        >
          <span className="--icon">{mailIcon}</span> {selectedUser?.email}
        </span>
          {console.log("details user selected user : ", selectedUser)}
        {(Number(selectedUser?.type) === 3 || selectedUser?.user_business_type == 2) && (
          <section className="performance">
            <Title className="rating">
              {stats?.overallScore ? (stats.overallScore / 2).toFixed(2) : 0}
            </Title>
            <figure className="rating-info">
              <Rate
                allowHalf
                value={stats?.overallScore ? stats.overallScore / 2 : 0}
                className="stars"
              />
              <figcaption className="caption">Overall Performance</figcaption>
            </figure>
          </section>
        )}
      </article>
    </section>
  </Card>

  {/* RIGHT SECTION */}
  <div className="info-stats-container" style={{ flex: 2, display: "flex", flexDirection: "column", gap: 16 }}>
    {/* PROFILE INFORMATION CARD */}
    <Card
      className="modern-card info-card"
      title="Profile Information"
      bordered={false}
      style={{
        flex: 1,
        boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        minHeight: "180px",
        padding:0,
      }}
    >
      <Table
        columns={columns}
        dataSource={getData(selectedUser)}
        showHeader={false}
        pagination={false}
        rowClassName="info-row --user-details"
      />
    </Card>

    {/* GENERAL STATS CARD */}
    {(Number(selectedUser?.type) === 3 || selectedUser?.user_business_type == 2) && (
      <Card
        className="modern-card stats-card"
        title="My Performance"
        bordered={false}
        style={{
          flex: 1,
          boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
          minHeight: "280px",
        }}
      >
        <section className="tiles-container">
          {generalStats.map((data) => (
            <UserTile key={data.title} {...data} />
          ))}
        </section>
      </Card>
    )}

  {/* Uncomment below section when you have to show Tasks */}
          {/* <section className="task-breakdown">
            <Title className="--title">Task</Title>
            <section className="tiles-container">
              {tasks.map((data) => (
               <UserTile {...data} />
             ))}
            </section>
          </section> */}
      </div>
        </div>
     {/*    <section className="updated-at">Last Updated 5 days ago</section> */}
     { Number(selectedUser?.type) === 3 &&   <div className="user-detail-row-full"> <TripsTable  /></div>}
      </main>
     
    </>
  );
}
